import Carousel from 'react-bootstrap/Carousel';

var heroData = [
  {
    id: 1,
    image: require('../assets/images/img-hero1.jpg'),
    title: 'The perfect design for your website',
    description: 'The perfect design for your website blends creativity, functionality, and user experience. It captures your brand’s identity, engages visitors, and guides them smoothly to your goals. With responsive layouts, modern visuals, and clear navigation, a well-crafted design ensures your website looks professional, builds trust, and leaves a lasting impression.',
    link: 'https://www.google.com'
  },
  {
    id: 2,
    image: require('../assets/images/img-hero2.jpg'),
    title: 'Start Your Future Financial Plan',
    description: 'Start your future financial plan today by setting clear goals and taking control of your money. From saving and investing to budgeting wisely, every step builds security and confidence. Planning early helps you prepare for unexpected challenges, achieve dreams, and create lasting stability for yourself and your loved ones.',
    link: 'https://www.facebook.com'
  },
  {
    id: 3,
    image: require('../assets/images/img-hero3.jpg'),
    title: 'Enjoy the Difference',
    description: 'Enjoy the difference that true quality and care bring to your life. From thoughtful details to lasting value, the right choice transforms ordinary moments into extraordinary experiences. It’s not just about products or services—it’s about how they make you feel, creating satisfaction, trust, and joy in every interaction.',
    link: 'https://www.twitter.com'
  }
]

function AppHero() {
  return (
    <section id="home" className="hero-block">
       <Carousel>
          {
            heroData.map(hero => {
              return (
                <Carousel.Item key={hero.id}>
                  <img
                    className="d-block w-100"
                    src={hero.image}
                    alt={"slide " + hero.id}
                  />
                  <Carousel.Caption>
                    <h2>{hero.title}</h2>
                    <p>{hero.description}</p>
                    <a className="btn btn-primary" href={hero.link}>Learn More <i className="fas fa-chevron-right"></i></a>
                  </Carousel.Caption>             
                </Carousel.Item>
              );
            })
          }
      </Carousel>
    </section>
  );
}

export default AppHero;